import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mt-4 mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "primary-text" }, "CREATE PITCH", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "primary-text fw-bold" }, [
  /*#__PURE__*/_createTextVNode(" This section helps you to create all sorts of needs and will form the basis of your"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" smart-capital funding campaign on 7Founders.... "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://7founders.com/pitch-f"
  }, " example. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPitch = _resolveComponent("PublicPitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.founderPublicPitch.showDrawer(_ctx.founder.id))),
        class: "btn btn-sm btn-primary preview-btn"
      }, " PREVIEW "),
      _createVNode(_component_PublicPitch, { ref: "founderPublicPitch" }, null, 512)
    ]),
    _hoisted_3
  ], 64))
}